/**
 * @generated SignedSource<<b4ed664f990d92e97f7aedb191cc583c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type activateAddonDialogQuery$variables = {
  addonKey: string;
  currencyCode: string;
};
export type activateAddonDialogQuery$data = {
  readonly addon: {
    readonly addonID: number;
    readonly billingSystemAddonID: string | null;
    readonly description: string;
    readonly name: string;
    readonly price: number;
    readonly rates: ReadonlyArray<{
      readonly feePerc: number;
      readonly feeValue: number;
    }>;
  } | null;
  readonly ecommerceSettings: {
    readonly ecommerceName: ECommerce;
  } | null;
};
export type activateAddonDialogQuery = {
  response: activateAddonDialogQuery$data;
  variables: activateAddonDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "addonKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currencyCode"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "addonKey",
    "variableName": "addonKey"
  },
  {
    "kind": "Variable",
    "name": "currencyCode",
    "variableName": "currencyCode"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addonID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingSystemAddonID",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeValue",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feePerc",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "activateAddonDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Addon",
        "kind": "LinkedField",
        "name": "addon",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AddonRate",
            "kind": "LinkedField",
            "name": "rates",
            "plural": true,
            "selections": [
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v9/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "activateAddonDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Addon",
        "kind": "LinkedField",
        "name": "addon",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AddonRate",
            "kind": "LinkedField",
            "name": "rates",
            "plural": true,
            "selections": [
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v10/*:: as any*/)
            ],
            "storageKey": null
          },
          (v10/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v9/*:: as any*/),
          (v10/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3244303a467f613e8aa7ef422ebf9778",
    "id": null,
    "metadata": {},
    "name": "activateAddonDialogQuery",
    "operationKind": "query",
    "text": "query activateAddonDialogQuery(\n  $addonKey: String!\n  $currencyCode: String!\n) {\n  addon(addonKey: $addonKey, currencyCode: $currencyCode) {\n    addonID\n    billingSystemAddonID\n    name\n    price\n    description\n    rates {\n      feeValue\n      feePerc\n      id\n    }\n    id\n  }\n  ecommerceSettings {\n    ecommerceName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b351cfebf722add40fb0f61a8a7ba4f";

export default node;
